import { useCallback } from 'react';
import {
  getListingDetailsModalConfigWithDeepLink,
  getListingDetailsRelativeUrl,
} from 'src/utils/inventoryUtils';
import {
  ActionOutboxEntityType,
  ListingDetailDataField,
} from 'src/WebApiController';

import { useEntityActions } from './useEntityActions';
import { useMatchMedia } from './useMatchMedia';

/**
 * Hook for listing-specific actions like opening listing modals.
 */
export const useListingActions = () => {
  const { loadEntityAndOpenModal } = useEntityActions();
  const isMobile = useMatchMedia('mobile');

  const openListingModal = useCallback(
    (
      listingId: number | string,
      dataFields: ListingDetailDataField[] = [ListingDetailDataField.Basic],
      forceRefresh = false,
      resetData = false,
      sectional = false,
      mouseEvent?: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
      if (mouseEvent && (mouseEvent.metaKey || mouseEvent.ctrlKey)) {
        mouseEvent.preventDefault();
        const url = getListingDetailsRelativeUrl(listingId);
        window.open(url, '_blank');
        return;
      }
      const getListingModalConfig = (id: number | string) => {
        return getListingDetailsModalConfigWithDeepLink(isMobile, id);
      };
      loadEntityAndOpenModal(
        ActionOutboxEntityType.Listing,
        listingId,
        null,
        forceRefresh,
        dataFields as string[],
        resetData,
        sectional,
        getListingModalConfig
      );
    },
    [loadEntityAndOpenModal]
  );

  const openListingWithAllData = useCallback(
    (listingId: number | string) => {
      openListingModal(
        listingId,
        Object.values(ListingDetailDataField) as ListingDetailDataField[]
      );
    },
    [openListingModal]
  );

  return {
    openListingModal,
    openListingWithAllData,
  };
};
